module.exports = __webpack_public_path__ + "static/img/h-second.3be909ee.png";